/**
 * Field names a builder may not use because the platform owns a column of that name on the same table
 * (plan §26). Mirror of olympus-functions `src/entity/reserved-field-names.ts`, which is the rule —
 * this only gives early feedback. Exact, case-sensitive.
 */
export const RESERVED_FIELD_NAMES: readonly string[] = [
  'tenant_id',
  'removed_at',
  'systemRemovedAt', // the removal marker since 2026-10-05 (mirrors olympus-functions entity/reserved-field-names.ts)
  'system_deleted_at',
  'system_remove_requested',
  'system_erased_at', // erased-person marker (olympus-functions user/erase-rules.ts)
];
export const RESERVED_FIELD_SUFFIX = '_filter_cache_system';

export function isReservedFieldName(name: string): boolean {
  return RESERVED_FIELD_NAMES.includes(name) || name.endsWith(RESERVED_FIELD_SUFFIX);
}

export function reservedFieldNameMessage(name: string): string {
  return `'${name}' is reserved by Zavo. Choose another name.`;
}
